import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxImage from '../features/image-parallax';
import scrollButton from '../features/scroll-button';
import {customScrollbar} from '../features/custom-scrollbar';

register('hero', [parallaxImage, scrollButton, customScrollbar]);
